import { createSlice } from "@reduxjs/toolkit";

const tabs = [
  {
    title: "Registration",
  },
  {
    title: "Forms & Modules",
  },
  {
    title: "Compliance",
  },
  {
    title: "Files",
  },
  {
    title: "Feed",
  },
];

const mockStats = [
  {
    title: "Overall Compliance",
    value: 92,
  },
  {
    title: "Documentation Quality",
    value: 88,
  },
  {
    title: "Policy Adherence",
    value: 95,
  },
  {
    title: "Risk Management",
    value: 60,
  },
];

const carouselData = [
  {
    title: "Register as a Provider",
    description:
      "To register as a provider, you need to select the types of support services you will offer. This helps ensure that participants can find the right providers for their needs.",
    imageUrl: require("../../assets/images/carousel-image.png"),
    color: "var(--bgDark)",
  },
  {
    title: "Complete Your NDIS Application",
    description:
      "To register as a provider, you need to select the types of support services you will offer. This helps ensure that participants can find the right providers for their needs.",
    imageUrl: require("../../assets/images/carousel-image.png"),
    color: "#F59432",
  },
  {
    title: "Receive Your Scope of Audit Form",
    description:
      "To register as a provider, you need to select the types of support services you will offer. This helps ensure that participants can find the right providers for their needs.",
    imageUrl: require("../../assets/images/carousel-image.png"),
    color: "#F9C85F",
  },
  {
    title: "Choose an Auditor for Your Audit",
    description:
      "To register as a provider, you need to select the types of support services you will offer. This helps ensure that participants can find the right providers for their needs.",
    imageUrl: require("../../assets/images/carousel-image.png"),
    color: "var(--green)",
  },
  {
    title: "Use NAVI: Your AI Assistant",
    description:
      "To register as a provider, you need to select the types of support services you will offer. This helps ensure that participants can find the right providers for their needs.",
    imageUrl: require("../../assets/images/carousel-image.png"),
    color: "#00D0FF",
  },
];

const summaryData = [
  {
    title: "Training and Development",
    subTitle: "Register",
    dueDate: new Date().toISOString(),
    status: "incomplete",
  },
  {
    title: "Employee and Worker",
    subTitle: "Register",
    dueDate: new Date().toISOString(),
    status: "pending",
  },
  {
    title: "Health and Safety",
    subTitle: "Register",
    dueDate: new Date().toISOString(),
    status: "pending",
  },
  {
    title: "Incident and Complaint",
    subTitle: "Register",
    dueDate: new Date().toISOString(),
    status: "complete",
  },
];

const collapseData = [
  {
    title: "NDIS Verification Pack",
  },
  {
    title: "NDIS Certification Pack (Core Module)",
  },
  {
    title: "NDIS Module 1: High Intensity",
  },
  {
    title: "NDIS Module 2: Behaviour Support",
  },
  {
    title: "NDIS Module 3: Early Childhood Support",
  },
  {
    title: "NDIS 4: Support Coordinator",
  },
  {
    title: "NDIS 5: SDA",
  },
];

const initialState = {
  tabs,
  activeTab: tabs[0].title,
  stats: mockStats,
  carouselData,
  summaryData,
  collapseData,
  activeDrawer: "",
  drawerActiveTab: "",
  auditDrawer: "",
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setActiveDrawer: (state, action) => {
      state.activeDrawer = action.payload;
    },
    setDrawerActiveTab: (state, action) => {
      state.drawerActiveTab = action.payload;
    },
    setAuditDrawer: (state, action) => {
      state.auditDrawer = action.payload;
    },
  },
});

export const { setActiveTab, setDrawerActiveTab, setAuditDrawer } =
  homeSlice.actions;

export default homeSlice.reducer;
